import type { Workspace } from '@gripp/shared-logic';
import { ScrollView, StyleSheet, Text } from 'react-native';
import { Colors } from '../../themes/colors';
import { ImpersonateWorkspaceChip } from './impersonateWorkspaceChip';

type WorkspaceColumnProps = {
  workspaces?: Workspace[]; // array of workspaces
  canImpersonate?: boolean;
};

export const WorkspaceColumn = ({
  workspaces,
  canImpersonate,
}: WorkspaceColumnProps) => {
  if (!workspaces || workspaces.length === 0) {
    return <Text style={styles.empty}>-</Text>;
  }

  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      style={styles.container}
    >
      {workspaces.map((ws, index) =>
        canImpersonate ? (
          <ImpersonateWorkspaceChip
            key={ws.id || index}
            workspace={ws}
            additionalStyle={styles.chip}
          />
        ) : (
          <Text key={ws.id || index} style={styles.nameOnly}>
            {ws.name}
          </Text>
        )
      )}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  chip: {
    marginRight: 4,
  },
  nameOnly: {
    margin: 4,
    fontSize: 14,
    color: Colors.black,
  },
  empty: {
    fontSize: 14,
    color: Colors.primaryGrayBackground,
  },
});
